const VALID_PROTOCOLS = /^(https?:\/\/|tg:\/\/)/i;
const TG_USER_URL = /^tg:\/\/user\?id=\d+$/i;
const HAS_DOT = /\.\w{2,}/;

export function sanitizeUrl(url: string): string {
  const trimmed = url.trim();
  if (trimmed === '') return '';
  if (VALID_PROTOCOLS.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function isValidLinkUrl(url: string): boolean {
  const sanitized = sanitizeUrl(url);
  if (sanitized === '') return false;
  if (TG_USER_URL.test(sanitized)) return true;
  try {
    const parsed = new URL(sanitized);
    return (parsed.protocol === 'http:' || parsed.protocol === 'https:') && HAS_DOT.test(parsed.hostname);
  } catch {
    return false;
  }
}
